/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { authApiKeysList } from "../../funcs/authApiKeysList.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListScopedApiKeysRequest$inboundSchema,
};

export const tool$authApiKeysList: ToolDefinition<typeof args> = {
  name: "auth-api-keys-list",
  description: `List scoped API keys

List the caller's scoped API keys (metadata only — never the secret). Optional \`?orgId=&teamId=\` narrows; a key caller is scoped to its own org.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await authApiKeysList(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
